import { useState } from "react";
import useCurrentShopSuspense from "./use-current-shop-suspense";
import { useTemplatesEditorRouting } from "../context/templates-editor-routing-context";


export function useTemplateActions() {
  const { openTemplate } = useTemplatesEditorRouting();
  const { data: shop } = useCurrentShopSuspense();

  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

  const navigateToTemplate = (templateId: string) => {
    openTemplate?.(templateId);
  };

  const openCreateModal = () => setIsCreateModalOpen(true);

  return {
    shop,
    isCreateModalOpen,
    setIsCreateModalOpen,
    navigateToTemplate,
    openCreateModal,
  };
}
